import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Swal from 'sweetalert2';
import { Box, CircularProgress } from "@mui/material";

const Index = () => {
    const navigate = useNavigate();
    const hasLoggedOut = useRef(false); // Prevent multiple executions

    useEffect(() => {
        const verifyLoginOut = async () => {
            // Prevent multiple executions
            if (hasLoggedOut.current) {
                return;
            }
            hasLoggedOut.current = true;

            console.log("Logging out...");
            Cookies.remove("user_id");
            Cookies.remove("company_id");

            // Show logout success with SweetAlert
            await Swal.fire({
                title: 'Logget ut!',
                text: 'Du har blitt logget ut.',
                icon: 'success',
                timer: 2000,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false
            });
            
            // Show logout confirmation only once
           // alert("You have been logged out.");
           Swal.fire({
            title: 'Success',
            text: 'Du har blitt logget ut.',
            icon: 'success',
            confirmButtonText: 'OK'
           });
            // Navigate to login page
            navigate("/");
        };

        verifyLoginOut();
    }, []); // Remove navigate from dependencies to prevent re-runs

    return (
    <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh' 
    }}>
        <CircularProgress />
    </Box>
    );
};

export default Index;
